/**
 * Dark Mode Toggle
 *
 * Reads/writes 'dark' class on <html>. Persists to localStorage.
 * Respects prefers-color-scheme on first visit.
 */

const STORAGE_KEY = 'wm-color-scheme';
const DARK_CLASS = 'dark';

function getPreferred(): 'dark' | 'light' {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyScheme(scheme: 'dark' | 'light'): void {
  document.documentElement.classList.toggle(DARK_CLASS, scheme === 'dark');
  document.querySelectorAll<HTMLElement>('[data-dark-toggle]').forEach(btn => {
    btn.setAttribute('aria-pressed', String(scheme === 'dark'));
    btn.setAttribute(
      'aria-label',
      scheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
    );
  });
}

export function initDarkMode(): void {
  // Apply preference immediately (before paint)
  applyScheme(getPreferred());

  document.querySelectorAll<HTMLElement>('[data-dark-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const next = document.documentElement.classList.contains(DARK_CLASS) ? 'light' : 'dark';
      localStorage.setItem(STORAGE_KEY, next);
      applyScheme(next);
    });
  });
}
